// Japanese locale for vue-easytable
export default {
  pagination: {
    goto: '移動',
    page: '',
    itemsPerPage: ' / ページ',
    total: total => {
      return `合計 ${total}`;
    },
    prev5: '前の5ページ',
    next5: '次の5ページ',
  },
  table: {
    confirmFilter: '確認',
    resetFilter: 'リセット',
  },
};
